import { TableCell } from '@mui/material'
import React from 'react'
import { TableCellProps } from '@mui/material/TableCell/TableCell'

export default function CustomHeadCell(props: TableCellProps) {
	return <TableCell sx={{ fontWeight: 'bold', border: 'none' }} {...props} />
}
